import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from '../../../services/Auth/auth';
import useUserStore from '../../../store/userStore';
import { setCookie } from "../../../utils/cookies";
import PopupLoginError from "../../../components/Popup/LoginError";
import { useLanguage } from "../../../hooks/useLanguage";
import EyeIconOff from '../../../assets/icon/icon-off-show.png';
import EyeIconOn from '../../../assets/icon/icon-on-show.png';


function Login() {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        userid: '',
        password: '',
        keepLoginChk: false
        });

        const[showIdError, setShowIdError] = useState(false)
        const[isPopupLoginError, setIsPopupLoginError] = useState("")

        // 비밀번호 표시/숨김 상태 추가
        const [showPassword, setShowPassword] = useState(false);

        // 비밀번호 토글 함수 추가
        const togglePasswordVisibility = () => {
            setShowPassword(!showPassword);
        };

        const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (name === 'userid' && value !== '') {
            setShowIdError(false);
        }
        };


        const handleLogin = async (e) => {
        e.preventDefault();
        const {userid, password, keepLoginChk} = formData;

        if (!userid) {
            setShowIdError(true);
            return;
        }

        try {
            const response = await loginUser(userid, password, keepLoginChk ? 'Y' : 'N');

            if (response?.data?.code === 200) {
                const {access_token} = response.data.data;
                const decodedPayload = JSON.parse(atob(access_token.split('.')[1]));
                const savedEmail = localStorage.getItem('userEmail'); // 로컬스토리지에서 이메일값 받아오기

                const userInfo = {
                    ...decodedPayload,
                    user_name: decodedPayload.username,
                    email: savedEmail || response.data.data.email,
                    agree_flag: response.data.data.agree_flag
                };

                // 토큰을 30일 유효기간을 가진 쿠키로 저장
                setCookie('access_token', access_token, 30);

                if (keepLoginChk) {
                    localStorage.setItem('autoLogin', 'true');
                    localStorage.setItem('savedId', userid);
                    localStorage.setItem('savedPassword', btoa(password));
                }

                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                useUserStore.getState().updateTokens(access_token);
                useUserStore.getState().updateUserInfo(userInfo);

                // agree_flag가 'R'인 경우 로그인 후 팝업 표시
                if (response.data.data.agree_flag === 'R') {
                    setIsPopupLoginError({
                        message: t("authentication_info_expired"),
                        action: 'navigate_profile_edit'
                    });
                } else {
                    navigate('/');
                }
            } else {
                // 서버에서 200이 아닌 코드를 반환한 경우
                setIsPopupLoginError(response?.data?.message || '아이디 또는 비밀번호를 확인해주세요.');
            }
        } catch (error) {
            setIsPopupLoginError(error.response?.data?.message || '아이디 또는 비밀번호를 확인해주세요.');
        }
    };

        // Enter 키를 눌렀을 때 로그인 처리
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                handleLogin(e);
            }
        };

    const handleConfirm = () => {
        if (isPopupLoginError.action === 'navigate_profile_edit') {
            navigate('/myPage/profile/edit');
        }
        setIsPopupLoginError(false);
    };

    return (
        <div>
            <section className="auth_section min_height">
                <div className="inner">
                    <div className="section_title">
                        <h3>
                            {t("login")}
                        </h3>
                    </div>

                    <ul className="form_group login_con">
                        <li className="default_input lg flex-center-8 column">
                            <div className="w-100">
                                <input type="text" placeholder={t("email_id")} name="userid" onChange={handleChange} value={formData.userid} onKeyDown={handleKeyDown}/>
                            </div>
                            <div className="w-100">
                                <div className="password_input_wrapper">
                                    <input 
                                        type={showPassword ? "text" : "password"} 
                                        placeholder={t("password")} 
                                        name="password" 
                                        onChange={handleChange} 
                                        value={formData.password} 
                                        onKeyDown={handleKeyDown} 
                                    />
                                    <button
                                        type="button"
                                        className="password_toggle_btn"
                                        onClick={togglePasswordVisibility}
                                    >
                                        <img 
                                            src={showPassword ? EyeIconOn : EyeIconOff} 
                                            alt="비밀번호 표시/숨김"
                                            width="20"
                                            height="20"
                                        />
                                    </button>
                                </div>
                                {showIdError && <span className="guide_text red">{t("enter_email")}</span>}
                            </div>
                        </li>
                        <li className="auth_find">
                            <div className="default_chk_box">
                                <input
                                    type="checkbox"
                                    id="login_chk"
                                    name="keepLoginChk"
                                    onChange={handleChange}
                                    checked={formData.keepLoginChk}
                                />
                                <label htmlFor="login_chk">
                                    <span>{t("keep_logged_in")}</span>
                                </label>
                            </div>
                            <div className="line_group">
                                <Link to="/auth/find/id" >
                                    {t("find_email")}
                                </Link>
                                <span></span>
                                <Link to="/auth/find/password" >
                                    {t("find_password")}
                                </Link>
                            </div>
                        </li>
                        <li className="d-flex">
                            <button type="button" className="default_btn black lg" onClick={handleLogin}>
                                {t("sign_in")}
                            </button>
                        </li>
                        <li>
                            <span>{t("first_time_user")}</span>
                            <Link to="/joinAgreement" style={{color:"var(--blue-50)",textDecorationLine: "underline", textUnderlineOffset: "2px"}}>{t("sign_up")}</Link>
                        </li>
                    </ul>
                    <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError} onConfirm={handleConfirm}/>
                </div>
            </section>
            
        </div>
    );
}

export default Login;